export enum ClassificacaoContaFilha {
  Ativo,
  Passivo,
  Resultado,
}
